<template>
  <div>
    <MenuBar />

    <div id="faqPage" class="mobileOnly">
      <FloatingMenu />

      <transition enter-active-class="animated fadeIn" appear>
        <div class="faqPageTitle">
          <span v-if="this.langChosen === 'gr'">คำถามที่พบบ่อย</span>
          <span v-else>FAQ</span>
        </div>
      </transition>

      <div class="faqContainer" v-if="this.langChosen === 'gr'">
        <transition-group name="fadeCustom" leave-active-class="animated fadeOut fadeCustom-leave-active">
          <div
            class="faqHead"
            @click="oneActive = !oneActive"
            :class="{ borderNeeded: oneActive, borderAll: oneActive === false }"
            key="headOne"
          >
            <div class="faqSign">{{ oneActive ? '-' : '+' }}</div>
            <div>จะขอรับรางวัล Sweepstakes ได้อย่างไร?</div>
          </div>

          <div class="faqBody" v-if="oneActive" key="bodyOne">
            <p>
              <b>ข้อกำหนดและแนวทางปฏิบัติ</b>
            </p>

            <p>เพียงโอนใบรับรองภาษีชุมชนบัตรประจำตัวประชาชนและตั๋วรางวัลไปที่สำนักงานใหญ่ลอตเตอรี่กรุงเทพ</p>

            <p>
              แสดงตั๋วที่ชนะของคุณต่อกรมกองทุนรวมการบัญชีและงบประมาณ
              ใส่ลายเซ็นของคุณที่ด้านหลังของตั๋วที่ชนะเพื่อระบุความเป็นเจ้าของที่แท้จริงของคุณ กรอกแบบฟอร์มการเรียกร้อง
            </p>

            <p>
              ไปที่กระทรวงการคลัง.
              แสดงตั๋วที่ได้รับการรับรองของคุณและแบบฟอร์มใบสมัครที่ได้รับการอนุมัติเพื่อเตรียมเช็คของคุณทันที.
            </p>

            <p>ลงนามในเช็คของคุณจากประธาน / ผู้จัดการทั่วไป จากนั้นรับรางวัล / เช็คที่กระทรวงการคลังอย่างถูกต้อง.</p>

            <p>ป้อนเช็คของคุณที่ธนาคารแห่งชาติกรุงเทพ.</p>

            <p>
              <b>เงื่อนไขการจ่ายรางวัล</b>
            </p>

            <p>
              รางวัลจะจ่ายให้กับผู้ถือหุ้นหรือตั๋วที่ได้รับรางวัลเมื่อนำเสนอและจัดส่งโดยมีเงื่อนไขว่าตั๋วจะปราศจากการตัดการลบหรือการย้อมสีทำให้ไม่สามารถอ่านหมายเลขใด
              ๆ ได้และมีเงื่อนไขว่า ไม่ได้รับคำสั่งศาลที่ จำกัด การจ่ายเงินลอตเตอรีซานโตรินีก่อนการชำระเงิน.
            </p>

            <p>รางวัลทั้งหมดที่จ่ายไม่ต้องเสียภาษี.</p>
          </div>

          <div
            class="faqHead"
            @click="twoActive = !twoActive"
            :class="{ borderNeeded: twoActive, borderAll: twoActive === false }"
            key="headTwo"
          >
            <div class="faqSign">{{ twoActive ? '-' : '+' }}</div>
            <div>จะรับรางวัล Lotto ได้อย่างไร?</div>
          </div>

          <div class="faqBody" v-if="twoActive" key="bodyTwo">
            <p>เขียนชื่อของคุณและวางลายเซ็นของคุณที่ด้านหลังของตั๋วที่ชนะก่อนที่จะรับรางวัลของคุณ</p>
            <p>
              คุณสามารถรับรางวัล 1 ยูโรถึง 100 ยูโรได้ที่ร้านล็อตโต้ที่ได้รับอนุญาตหรือที่สาขาลอตเตอรีในพื้นที่ของคุณ.
            </p>
            <p>
              ของรางวัลมูลค่ากว่า 3.500 บาทสูงสุด 125.000 บาทสามารถขอรับรางวัลได้ที่สำนักงานใหญ่ลอตเตอรี่กรุงเทพทุกแห่ง.
            </p>
            <p>
              รางวัลแจ็คพอตจะต้องได้รับการตรวจสอบและอ้างสิทธิ์ได้ที่สำนักงานใหญ่ลอตเตอรีของ ซานโตรินี.
            </p>
            <p>ในการชำระเงินสำหรับระบบโปรดดูแผนการจ่ายรางวัล.</p>
          </div>

          <div
            class="faqHead"
            @click="threeActive = !threeActive"
            :class="{ borderNeeded: threeActive, borderAll: threeActive === false }"
            key="headThree"
          >
            <div class="faqSign">{{ threeActive ? '-' : '+' }}</div>
            <div>วิธีสมัครเป็นโลโก้ลอตเตอรี่ออนไลน์;</div>
          </div>

          <div class="faqBody" v-if="threeActive" key="bodyThree">
            <ol>
              <li>
                ผู้สมัครจะต้องกรอกแบบฟอร์มใบสมัครสำหรับการโทรอย่างเป็นทางการ
                <br />แบบฟอร์มใบสมัครมีเอกสารแนบดังต่อไปนี้:
              </li>
              <ul>
                <li>ภาพร่าง / แผนที่ที่ตั้งของพื้นที่ขายที่เสนอ</li>
                <li>ภาพอาคารของพื้นที่ขายที่เสนอ.</li>
              </ul>
              <li>
                ลอตเตอรีซานโตรีนีจะดำเนินการตรวจสอบและประเมินผลทางเทคนิคของไซต์ที่เสนอ สำหรับขาย.
              </li>
              <li>
                ผู้สมัครจะได้รับแจ้งผลการประเมิน หากสถานที่ขายที่แนะนำคือ อย่างยั่งยืนจำเป็นต้องมีสิ่งต่อไปนี้:
              </li>
              <ul>
                <li>สำหรับผู้สมัครรายบุคคล</li>
                <li>สำหรับ บริษัท</li>
              </ul>
              <li>
                ลอตเตอรีซานโตรีนีแจ้งให้ผู้สมัครทราบเกี่ยวกับสถานะของแอปพลิเคชันบน
                ความพร้อมของสิ่งอำนวยความสะดวกด้านการสื่อสารในตลาดที่เสนอก่อนการติดตั้ง สิ่งอำนวยความสะดวก.
              </li>
              <li>ผู้สมัครจะต้องได้รับแจ้งเมื่อสร้างแท่นวางสินค้า</li>
              <li>เพื่อติดตั้งเทอร์มินัล</li>
              <li>ชำระเงินในลอตเตอรีของซานโตรินีสำหรับค่าธรรมเนียมการดำเนินการ</li>
              <li>ชำระเงินในค่าติดตั้ง Bangkok ลอตเตอรี</li>
              <li>การชำระเงินค้ำประกันให้กับ GSIS</li>
              <li>ใบสมัครสำหรับการฝึกอบรมระหว่างการทำงานของเครื่องปลายทาง</li>
              <li>
                ไปที่แผนกคอนเทนเนอร์เพื่อหาวัสดุสิ้นเปลือง ลอตเตอรี่จะ จัดทำโดย Bangkok Lottery
              </li>
              <li>การลงนามในสัญญาขององค์กรกับ Lottery of Bangkok</li>
              <li>สำหรับการเปิดใช้งานออนไลน์</li>
            </ol>

            <p>
              <b> หมายเหตุ:</b>
            </p>
            <ul>
              <li>
                ตรวจสอบให้แน่ใจว่าใบสมัครสมบูรณ์และแนบเอกสารที่จำเป็นทั้งหมดแล้ว ที่ไม่สมบูรณ์
                การเรียกร้องจะไม่ถูกดำเนินการ
              </li>
              <li>แอปพลิเคชันทั้งหมดอยู่ภายใต้การประเมินก่อนการอนุมัติ</li>
            </ul>
          </div>

          <div
            class="faqHead"
            @click="fourActive = !fourActive"
            :class="{ borderNeeded: fourActive, borderAll: fourActive === false }"
            key="headFour"
          >
            <div class="faqSign">{{ fourActive ? '-' : '+' }}</div>
            <div>ข้อกำหนดการสมัครลอตเตอรี</div>
          </div>

          <div class="faqBody" v-if="fourActive" key="bodyFour">
            <ol type="A">
              <li>ผู้สมัครจะต้อง:</li>
              <ul>
                <li>พลเมืองกรีก</li>
                <li>อายุอย่างน้อย 21 ปี</li>
              </ul>
              <li>ผู้สมัครจะต้องกรอกข้อมูลและส่ง:</li>
              <ul>
                <li>ผู้สมัครรายบุคคล:</li>
                <ol>
                  <li>สาม (3) รหัสสุดท้าย (2 x 2)</li>
                  <li>
                    รูปภาพประจำตัวล่าสุดสาม (3) รูป (2 x 2) ของคู่สมรส; จดหมายแสดงความจำนง;
                    ลอตเตอรีออนไลน์ข้อมูลส่วนบุคคล แผ่น;
                  </li>
                  <li>หลักฐานรายได้:</li>
                  <ul>
                    <li>สำหรับผู้ประกอบอาชีพอิสระ:</li>
                    <ul>
                      <li>การขอคืนภาษีเงินได้</li>
                      <li>การจดทะเบียนธุรกิจ</li>
                      <li>งบการเงินที่ตรวจสอบแล้ว</li>
                    </ul>
                    <li>สำหรับพนักงาน:</li>
                    <ul>
                      <li>การขอคืนภาษีเงินได้</li>
                      <li>การจดทะเบียนธุรกิจ</li>
                      <li>ใบรับรองรายได้</li>
                    </ul>
                  </ul>
                  <li>หลักฐานการเป็นเจ้าของ / การเช่าทางออก</li>
                  <ul>
                    <li>สำหรับเจ้าของ:</li>
                    <ul>
                      <li>โฉนดที่ดินหรือ TCT</li>
                    </ul>
                    <li>สำหรับผู้เช่า:</li>
                    <ul>
                      <li>รับรอง</li>
                      <li>แบบฟอร์มการขออนุมัติการได้มาของอาคาร</li>
                    </ul>
                  </ul>
                  <li>NBI Clearance (ปัจจุบัน)</li>
                  <li>
                    Clear Clearance (การลงทะเบียนส่วนบุคคล) ร่าง / แผนผังเว็บไซต์ของเว็บไซต์ที่เสนอ องค์กร
                  </li>
                  <li>ภาพถ่ายสภาพภูมิอากาศของอาคาร</li>
                  <li>รูปภาพภายใน</li>
                </ol>
                <li>สำหรับ บริษัท :</li>
                <ol>
                  <li>ข้อมูลชีวภาพของเจ้าหน้าที่และกรรมการขององค์กร</li>
                  <li>
                    สำเนาสำเนาข้อบังคับของ บริษัท สำเนากฎหมายที่ตรวจสอบทางการเงินครั้งล่าสุด แถลงการณ์ I.T.R.
                    สำหรับปีก่อนหน้าทันทีหนังสือแสดงเจตจำนงสัญญาเช่าของเจ้าของ การสร้าง Sketch /
                    แผนผังเว็บไซต์ของเว็บไซต์สำนักงานที่เสนอรูปถ่ายของ ภาพปริมณฑลของอาคาร
                  </li>
                  <li>รูปภาพภายใน</li>
                </ol>
              </ul>

              <li>
                ผู้สมัครจะต้องตรวจสอบให้แน่ใจว่าเว็บไซต์ขององค์กรที่เสนอต้องมีคุณสมบัติดังต่อไปนี้ เกณฑ์:
              </li>
              <ol>
                <li>
                  ห่างจากโรงเรียน / สถานที่เรียน 100 เมตรภายใต้นโยบายลอตเตอรี
                  ซานโตรีนีและกฎที่มีอยู่เว้นแต่เว็บไซต์จะปิดหรือห้างสรรพสินค้า
                </li>
                <li>
                  การจราจรของมนุษย์ที่ดีเช่นในทางแยก / พื้นที่เชิงพาณิชย์หรือพลุกพล่าน ตำแหน่งของเขา เทอร์มินัล /
                  บูธควรเป็นกลยุทธ์ไม่ว่าจะอยู่ภายในห้างสรรพสินค้าหรือใน ซูเปอร์สโตร์.
                </li>
                <li>พื้นที่ไม่ท่วม</li>
                <li>
                  พื้นที่ชั้น 8 - 9 ตารางเมตรหรือมีมิเตอร์ธุรกิจที่มีขนาดอย่างน้อย 1.0 ม X 0.5 ม
                </li>
                <li>
                  โดยเฉพาะอย่างยิ่งกับการติดตั้งโทรศัพท์อย่างน้อยหนึ่ง (1) โทรศัพท์คงที่หรือเซลลูลาร์สำหรับการจัดการ
                  เปิดสาย โทรศัพท์ดังกล่าว (โดยเฉพาะโทรศัพท์บ้าน) ต้องอยู่ในระยะทางไม่เกิน
                  ห่างจากไซต์ปลายทางที่เสนอหนึ่ง (1) เมตร
                </li>
                <li>
                  ปิด (เพื่อความปลอดภัย) แต่มีด้านหน้าจากการจราจรของมนุษย์ / ทางเข้า ซุ้มต้อง
                  หันหน้าไปทางถนนหลักหรือในทิศทางที่มีการจราจรหนาแน่น ในกรณีของ
                  ห้างสรรพสินค้าห้างสรรพสินค้าหรือซูเปอร์มาร์เก็ตไม่จำเป็นต้องเป็นที่ตั้งของลอตเตอรี
                  รวมอยู่ด้วยหากมีความปลอดภัยในการปฏิบัติงานโดยเฉพาะอย่างยิ่งหลังเวลาเก็บรักษา
                </li>
                <li>พื้นที่แห้งและการระบายอากาศที่เพียงพอ (ควรมีเครื่องปรับอากาศ)</li>
                <li>ด้วยแหล่งจ่ายไฟ 220 VAC ปกติพร้อมสายดินและจุดจ่ายไฟที่ใช้ได้</li>
                <li>
                  พร้อมชั้นวาง / เมตร / โต๊ะสำหรับติดตั้งขั้วต่อโมเด็มและที่เก็บวัสดุ หวย.
                  หากไม่มีตัวแทนจะได้รับแจ้งเมื่อสร้างเสร็จ
                </li>
                <li>
                  ด้วยผู้ปฏิบัติงานที่พร้อมสำหรับการฝึกอบรมการใช้งานเครื่องปลายทางควร
                  เจ้าหน้าที่พิเศษหนึ่งคนและพนักงานสำรองหนึ่งคนต่ออาคารผู้โดยสาร ตัวแทนนี้จะได้รับแจ้ง
                  เมื่อนักบินจะได้รับการฝึกอบรม
                </li>
                <li>เวลาเปิดทำการหลักคือ 07.00 น. - 20:30 น. เจ็ด (7) วันต่อสัปดาห์</li>
              </ol>
              <li>
                ห่างจากร้านล็อตโต้ที่มีอยู่อย่างน้อย 100 เมตรตามข้อบังคับ ลอตเตอรีของซานโตรินี.
              </li>
              <li>การตรวจสอบทางเทคนิคของไซต์ผู้ให้บริการที่ได้รับอนุมัติ</li>
            </ol>
          </div>

          <div
            class="faqHead"
            @click="fiveActive = !fiveActive"
            :class="{ borderNeeded: fiveActive, borderAll: fiveActive === false }"
            key="headFive"
          >
            <div class="faqSign">{{ fiveActive ? '-' : '+' }}</div>
            <div>ข้อกำหนดสำหรับความช่วยเหลือทางการแพทย์มีอะไรบ้าง</div>
          </div>

          <div class="faqBody" v-if="fiveActive" key="headFive">
            <ul>
              <li>การขอยา</li>
              <ul>
                <li>จดหมายสมัครงานส่งถึง Hon ประธานกรรมการและ / หรือผู้จัดการทั่วไป</li>
                <li>
                  ต้นฉบับ / รับรองสำเนาถูกต้องของสรุปทางการแพทย์ลงนามโดยถูกต้อง แพทย์ที่รักษา. (หมายเหตุ:
                  รวมเลขที่ใบอนุญาตแพทย์)
                </li>
                <li>
                  ใบสั่งยาที่ลงนามโดยแพทย์ผู้รักษาโดยมีค่าใช้จ่ายจากร้านขายยาของโรงพยาบาล รวม:
                  <br />
                  ในกรณีที่ไม่มียาจากร้านขายยาของโรงพยาบาลก ใบรับรองการไม่มียาจากร้านขายยาของโรงพยาบาลใน Lottery of
                  Bangkok
                </li>
                <li>
                  สำเนาบัตรประจำตัวประชาชนที่มีรูปสุดท้ายของผู้สมัครพร้อมลายเซ็นของผู้สมัคร ส่วนหลัง
                </li>
              </ul>
              <li>การประยุกต์ใช้ในห้องปฏิบัติการ / ขั้นตอนการวินิจฉัย</li>
              <ul>
                <li>จดหมายสมัครงานส่งถึง Hon ประธานกรรมการและ / หรือผู้จัดการทั่วไป</li>
                <li>
                  ต้นฉบับ / รับรองสำเนาถูกต้องของสรุปทางการแพทย์ลงนามโดยถูกต้อง แพทย์ที่รักษา. (หมายเหตุ:
                  รวมเลขที่ใบอนุญาตแพทย์)
                </li>
                <li>
                  ใบสมัครของแพทย์ผู้รักษาที่ลงนามถูกต้อง (หมายเหตุ: รวมเลขที่ใบอนุญาต แพทย์)
                </li>
                <li>
                  เสนอราคาอย่างเป็นทางการจากแผนก / แผนกห้องปฏิบัติการของโรงพยาบาล
                  <br />
                  ในกรณีที่ไม่สามารถใช้ห้องปฏิบัติการ / ขั้นตอนการวินิจฉัยได้จาก
                  โรงพยาบาลต้องส่งใบรับรองการไม่พร้อมใช้งานของขั้นตอนโดยโรงพยาบาลไปที่ ลอตเตอรีของซานโตรินี.
                </li>
                <li>
                  สำเนาบัตรประจำตัวประชาชนที่มีรูปสุดท้ายของผู้สมัครพร้อมลายเซ็นของผู้สมัคร ส่วนหลัง
                </li>
              </ul>
              <li>ขอเงินรักษาตัวในโรงพยาบาล</li>
              <ul>
                <li>จดหมายสมัครงานส่งถึง Hon ประธานกรรมการและ / หรือผู้จัดการทั่วไป</li>
                <li>
                  ต้นฉบับ / รับรองสำเนาถูกต้องของสรุปทางการแพทย์ลงนามโดยถูกต้อง แพทย์ที่รักษา. (หมายเหตุ:
                  รวมเลขที่ใบอนุญาตแพทย์)
                </li>
                <li>
                  ใบเรียกเก็บเงินบัญชี / โรงพยาบาลตรวจสอบโดยเจ้าหน้าที่เรียกเก็บเงิน / เครดิต หัวหน้างาน.
                </li>
                <li>
                  จดหมายรับรองจากฝ่ายบริการสังคมของโรงพยาบาลถ้ามีหรือจากผู้จัดการ การรับรองและการเรียกเก็บเงิน
                </li>
              </ul>
              <li>ขอเครื่องช่วยฟัง</li>
              <ul>
                <li>จดหมายสมัครงานส่งถึง Hon ประธานกรรมการและ / หรือผู้จัดการทั่วไป</li>
                <li>
                  สำเนาต้นฉบับของรายงานการประเมินเสียงซึ่งลงนามโดยนักโสตทัศนศึกษา
                </li>
                <li>ราคาหนึ่งหรือสองราคาจากศูนย์การได้ยินทุกแห่ง</li>
                <li>สำเนาบัตรประจำตัวประชาชนพร้อมรูปถ่ายสุดท้ายของผู้สมัครพร้อมลายเซ็น</li>
              </ul>
              <li>ขอรากเทียม / ขาเทียม / วีลแชร์</li>
              <ul>
                <li>จดหมายสมัครงานส่งถึง Hon ประธานกรรมการและ / หรือผู้จัดการทั่วไป</li>
                <ol>
                  <li>คำขอปลูกถ่าย / คำมั่นสัญญา</li>
                  <ul>
                    <li>
                      สำเนาสรุปทางการแพทย์ฉบับจริงหรือที่ได้รับการรับรองซึ่งลงนามโดยถูกต้อง แพทย์ที่รักษา. (หมายเหตุ:
                      รวมเลขที่ใบอนุญาตแพทย์)
                    </li>
                  </ul>
                  <li>คำขอเก้าอี้รถเข็น</li>
                  <ul>
                    <li>
                      ต้นฉบับหรือรับรองสำเนาถูกต้องของบทคัดย่อทางการแพทย์หรือใบรับรองแพทย์ที่มี
                      รายละเอียดรถเข็นที่ลงนามโดยแพทย์ผู้รักษา (หมายเหตุ: รวม จำนวนใบอนุญาตแพทย์)
                    </li>
                  </ul>
                </ol>
                <li>ราคาอย่างเป็นทางการสอง (2) ราคาจากสอง (2) บริษัท ที่แตกต่างกัน</li>
                <li>
                  หนึ่ง (1) ภาพร่างกายของผู้ป่วยที่ร้องขอรถเข็นและ อุปกรณ์เทียม
                </li>
              </ul>
              <li>ขอฟอกไต</li>
              <ul>
                <li>จดหมายสมัครงานส่งถึง Hon ประธานกรรมการและ / หรือผู้จัดการทั่วไป</li>

                <li>
                  ต้นฉบับ / รับรองสำเนาถูกต้องของสรุปทางการแพทย์ลงนามโดยถูกต้อง แพทย์ที่รักษา. (หมายเหตุ:
                  รวมเลขที่ใบอนุญาตแพทย์)
                </li>

                <li>
                  หนังสืออนุมัติจากศูนย์บริการทางโทรศัพท์หรือโรงพยาบาลที่ลอตเตอรีของ Bangkok มอบเงินบริจาค
                </li>
                <li>ข้อเสนอราคาอย่างเป็นทางการจากศูนย์บริการลูกค้า / โรงพยาบาล</li>
                <li>การรับรองการยอมรับโดยศูนย์ฟอกไต / โรงพยาบาล</li>
                <li>
                  ในกรณีที่โรงพยาบาลไม่มีตัวทำละลายและ / หรือยาหลังผ่าตัด
                  จะต้องส่งไปยังการรับรองลอตเตอรีของซานโตรินีหากไม่มีน้ำยาล้างไตและ / และยาหลังผ่าตัดจากโรงพยาบาล
                </li>
                <li>
                  สำเนาบัตรประจำตัวประชาชนที่มีรูปสุดท้ายของผู้สมัครพร้อมลายเซ็นของผู้สมัคร ส่วนหลัง
                </li>
              </ul>
            </ul>
          </div>
          <div class="stillHaveQuestion" key="stillHaveQuestion">
            คุณยังมีคำถามหรือไม่? ติดต่อเราได้ที่ admin@bangkoklotteries.com
          </div>
        </transition-group>
      </div>

      <div class="faqContainer" v-else>
        <transition-group name="fadeCustom" leave-active-class="animated fadeOut fadeCustom-leave-active">
          <div
            class="faqHead"
            @click="oneActive = !oneActive"
            :class="{ borderNeeded: oneActive, borderAll: oneActive === false }"
            key="headOne"
          >
            <div class="faqSign">{{ oneActive ? '-' : '+' }}</div>
            <div>How to Claim Sweepstakes Prize?</div>
          </div>

          <div class="faqBody" v-if="oneActive" key="bodyOne">
            <p>
              <b>Requirements and Guidelines</b>
            </p>

            <p>
              Simply bring your Community Tax Certificate, Identification Card and the Winning ticket/s to the Bangkok
              Lottery main office.
            </p>

            <p>
              Present your winning ticket/s at the Prize Fund Division, Accounting and Budget Department. Affix your
              signature at the back of winning ticket/s to establish your absolute ownership. Fill up claim form.
            </p>

            <p>
              Proceed to Treasury Department. Present your Authenticated winning ticket/s and approved claim form for
              immediate preparation of your check.
            </p>

            <p>
              Have your check signed by the Chairman / General Manager. Then properly receive your winning prize / check
              at the Treasury Department.
            </p>

            <p>Encash your check at the Bangkok National Bank.</p>

            <p>
              <b>Conditions for Payment of Prizes</b>
            </p>

            <p>
              Prizes shall be paid to the holder of share/s of a winning ticket upon presentation and surrender of the
              same, provided that the ticket/s is/are free from any mutilation, erasure or stain, making any number/s
              therein illegible, and provided further that no court injunction restraining the Bangkok Lottery to pay
              is received before payment.
            </p>

            <p>All prizes paid are tax-free.</p>
          </div>

          <div
            class="faqHead"
            @click="twoActive = !twoActive"
            :class="{ borderNeeded: twoActive, borderAll: twoActive === false }"
            key="headTwo"
          >
            <div class="faqSign">{{ twoActive ? '-' : '+' }}</div>
            <div>How to Claim Lotto Prize?</div>
          </div>

          <div class="faqBody" v-if="twoActive" key="bodyTwo">
            <p>
              Write your name and affix your signature at the back of your winning tickets before claiming your prize.
            </p>
            <p>
              Prize amounting to 1 EUR up to 100 EUR can be claimed at any authorized Lotto outlet or at the Bangkok
              Lottery Branch Offices in your area.
            </p>
            <p>
              Prizes worth more than 100 EUR up to 3.500 EUR can be claimed at any of the at the Bangkok Lottery main
              office.
            </p>
            <p>The JACKPOT PRIZE should be validated and claimed at the Bangkok Lottery main office.</p>
            <p>For the system prize payout, please refer to the Prize Pay-Out Chart.</p>
          </div>

          <div
            class="faqHead"
            @click="threeActive = !threeActive"
            :class="{ borderNeeded: threeActive, borderAll: threeActive === false }"
            key="headThree"
          >
            <div class="faqSign">{{ threeActive ? '-' : '+' }}</div>
            <div>How to Apply as an Online Lottery Agent?</div>
          </div>

          <div class="faqBody" v-if="threeActive" key="bodyThree">
            <ol>
              <li>
                The applicant is requested to fill-up the On-Line Lottery Application Form
                <br />The Application Form shall include the following attachments:
              </li>
              <ul>
                <li>Sketch/Location Map of the proposed outlet site.</li>
                <li>Picture of the building of the proposed outlet site.</li>
              </ul>
              <li>
                Bangkok Lottery shall conduct the inspection and technical evaluation of the proposed outlet site/s.
              </li>
              <li>
                The applicant shall be informed of the evaluation result. If the proposed outlet site is viable, the
                following shall be required:
              </li>
              <ul>
                <li>For Individual Applicant</li>
                <li>For Corporation</li>
              </ul>
              <li>
                Bangkok Lottery shall notify the applicant on the status of the application concerning the
                availability of communication facilities in the proposed outlet prior to installation of facilities.
              </li>
              <li>The applicant shall be informed when to fabricate lotto booth.</li>
              <li>For Terminal Installation.</li>
              <li>Payment to Bangkok Lottery for Processing Fee.</li>
              <li>Payment to Bangkok Lottery of an Installation Fee.</li>
              <li>Payment of Surety Bond to the GSIS.</li>
              <li>Request for training in the operation of terminal.</li>
              <li>
                Proceed to Merchandising Section for outlet provisions. Lottery outlets will be provided by the
                Bangkok Lottery.
              </li>
              <li>Signing of the Agency Contract with the Bangkok Lottery.</li>
              <li>For On-Line Activation.</li>
            </ol>

            <p>
              <b>Note:</b>
            </p>
            <ul>
              <li>
                Please ensure that Application Form is complete and that all required documents are attached. Incomplete
                requirements will not be processed.
              </li>
              <li>All application are subject to evaluation prior to approval.</li>
            </ul>
          </div>

          <div
            class="faqHead"
            @click="fourActive = !fourActive"
            :class="{ borderNeeded: fourActive, borderAll: fourActive === false }"
            key="headFour"
          >
            <div class="faqSign">{{ fourActive ? '-' : '+' }}</div>
            <div>On-Line Lottery Agents’ Application Requirements?</div>
          </div>

          <div class="faqBody" v-if="fourActive" key="bodyFour">
            <ol type="A">
              <li>Applicant must be:</li>
              <ul>
                <li>a Greek citizen</li>
                <li>at least 21 years old</li>
              </ul>
              <li>Applicant must accomplish and submit:</li>
              <ul>
                <li>Individual Applicant:</li>
                <ol>
                  <li>Three (3) latest ID pictures (2 x 2);</li>
                  <li>
                    Three (3) latest ID pictures (2 x 2) of spouse; Letter of INTENT; On-Line Lottery PERSONAL DATA
                    SHEET;
                  </li>
                  <li>Proof of Income:</li>
                  <ul>
                    <li>For Self-employed:</li>
                    <ul>
                      <li>Income Tax Return</li>
                      <li>Registration of Business</li>
                      <li>Audited Financial Statements</li>
                    </ul>
                    <li>For Employed:</li>
                    <ul>
                      <li>Income Tax Return</li>
                      <li>Registration of Business</li>
                      <li>Certificate of Income</li>
                    </ul>
                  </ul>
                  <li>Proof of Ownership/Lease of Outlet</li>
                  <ul>
                    <li>For Owner:</li>
                    <ul>
                      <li>Land Title or TCT</li>
                    </ul>
                    <li>For Lessee:</li>
                    <ul>
                      <li>Contract of Lease (Notarized)</li>
                      <li>Building Owner’s Authorization Form</li>
                    </ul>
                  </ul>
                  <li>NBI Clearance (Current)</li>
                  <li>Brgy Clearance (Personal Record) Sketch/Location Map of the Proposed Agency Site</li>
                  <li>Photograph of the Vicinity Photograph of the Building</li>
                  <li>Photograph of the Interior</li>
                </ol>
                <li>For Corporation:</li>
                <ol>
                  <li>Bio-data of Corporate Officers and Directors</li>
                  <li>
                    Photocopy of S.E.C Registration Photocopy of Articles of Incorporation Photocopy of By Laws Latest
                    audited Financial Statement I.T.R. for the immediately preceding year Letter of Intent Contract of
                    Lease Building Owner’s Authorization Sketch/Location Map of the Proposed Agency Site Photograph of
                    the Vicinity Photograph of the Building
                  </li>
                  <li>Photograph of the Interior</li>
                </ol>
              </ul>

              <li>Applicant must make sure that the Proposed Agency Site must comply with the following criteria:</li>
              <ol>
                <li>
                  100 meters away from schools/place of learning, subject to Bangkok Lottery policies and existing
                  rules, except if the location is enclosed or a shopping center.
                </li>
                <li>
                  Good human traffic, i.e. situated in commercial or busy intersections/areas. The location of
                  terminal/booth should be strategic if within a mall or superstore.
                </li>
                <li>The area does not get flooded.</li>
                <li>Floor space of 8 – 9 sq. meters or available business counter measuring at least 1.0 m X 0.5 m</li>
                <li>
                  Preferable with at least one (1) telephone facility, landline or cellular, for hotline operations.
                  Such telephone (specially landline) should be situated at no more than one (1) meter away from the
                  proposed terminal location.
                </li>
                <li>
                  Enclosed (for security purposes) but with frontage from human traffic/entry. Frontage must face main
                  road or to the direction of major traffic flow. In cases of malls, shopping centers or superstores,
                  the lottery location need not be enclosed provided there is security of operation, specially after
                  store hours.
                </li>
                <li>Dry floor space and proper ventilation (preferably air-conditioned).</li>
                <li>With regular power supply of 220 VAC, with grounding and available power point/s.</li>
                <li>
                  With available shelf/counter/cabinet for terminal installation, modem and storage of lottery
                  materials. If not currently available, the agent will be advised on when to fabricate.
                </li>
                <li>
                  With operators to be made available for training in the operation of the terminals preferably one
                  dedicated personnel and a back-up personnel per terminal. This agent will be advised on when the
                  operators will be trained.
                </li>
                <li>Major operating hours fall within 7:00AM – 8:30PM, seven (7) days a week.</li>
              </ol>
              <li>
                At least 100 meters away from any existing lotto outlet which shall be subject to Bangkok Lottery
                governing rules.
              </li>
              <ol>
                <li>National Capital Region – 100M</li>
                <li>Southern Tagalog and Bicol Region – 200 – 250M</li>
                <li>Northern and Central Luzon – 200 – 250M</li>
              </ol>
              <li>Approved technical site survey by carrier.</li>
            </ol>
          </div>

          <div
            class="faqHead"
            @click="fiveActive = !fiveActive"
            :class="{ borderNeeded: fiveActive, borderAll: fiveActive === false }"
            key="headFive"
          >
            <div class="faqSign">{{ fiveActive ? '-' : '+' }}</div>
            <div>What are the Requirements for Medical Assistance?</div>
          </div>

          <div class="faqBody" v-if="fiveActive" key="headFive">
            <ul>
              <li>Request for Medicines</li>
              <ul>
                <li>Letter of request addressed to the Hon. Chairman and/or General Manager</li>
                <li>
                  Original/or certified true photocopy of medical abstract duly signed by the attending physician.
                  (Note: Include physician’s license number)
                </li>
                <li>
                  Prescription duly signed by the attending physician with costing from the hospital pharmacy included:
                  <br />In cases wherein medicines are unavailable from the Hospital Pharmacy, a Certification on
                  unavailability of medicines from the Hospital Pharmacy must be submitted to Bangkok Lottery.
                </li>
                <li>
                  Photocopy of identification card with latest picture of the requesting person with his/her signature
                  indicated at the back.
                </li>
              </ul>
              <li>Request for Laboratory/Diagnostic Procedures</li>
              <ul>
                <li>Letter of request addressed to the Hon. Chairman and/or General Manager</li>
                <li>
                  Original/or certified true photocopy of medical abstract duly signed by the attending physician.
                  (Note: Include physician’s license number)
                </li>
                <li>Request from the attending physician duly signed (Note: Include physician’s license number)</li>
                <li>
                  Official Price Quotation from the Laboratory Section/Department of the Hospital
                  <br />In cases wherein Laboratory/Diagnostic Procedure is unavailable from the hospital, a
                  Certification on unavailability of the procedure from the hospital must be submitted to Bangkok
                  Lottery.
                </li>
                <li>
                  Photocopy of identification card with latest picture of the requesting person with his/her signature
                  indicated at the back.
                </li>
              </ul>
              <li>Request for Payment Hospitalization</li>
              <ul>
                <li>Letter of request addressed to the Hon. Chairman and/or General Manager</li>
                <li>
                  Original/or certified true photocopy of medical abstract duly signed by the attending physician.
                  (Note: Include physician’s license number)
                </li>
                <li>Statement of Account/Hospital Bill certified by the billing Officer/Credit Supervisor.</li>
                <li>
                  Endorsement letter from the hospital’s Social Service if there is any, or from the Credit and
                  Collection Officer for Pay patients.
                </li>
              </ul>
              <li>Request for Hearing Aid</li>
              <ul>
                <li>Letter of request addressed to the Hon. Chairman and/or General Manager</li>
                <li>Original copy of Audiological Evaluation Report duly signed by Audiometrist</li>
                <li>One or two price quotations from any hearing aid centers</li>
                <li>
                  Photocopy of identification card with latest picture of the requesting person with his/her signature
                </li>
              </ul>
              <li>Request for Implants/Prosthetic Devices/Wheelchair</li>
              <ul>
                <li>Letter of request addressed to the Hon. Chairman and/or General Manager</li>
                <ol>
                  <li>Implant/phosthesis request</li>
                  <ul>
                    <li>
                      Original or certified true photocopy of medical abstract duly signed by the attending physician.
                      (Note: Include physician’s license number)
                    </li>
                  </ul>
                  <li>Wheelchair request</li>
                  <ul>
                    <li>
                      Original or certified true photocopy of medical abstract or medical certificate with wheelchair
                      specification signed by the attending physician. (Note: Include physician’s license number)
                    </li>
                  </ul>
                </ol>
                <li>Two (2) official price quotations from two (2) different companies</li>
                <li>
                  One (1) whole body picture of requesting patient for request for wheelchair and prosthetic devices.
                </li>
              </ul>
              <li>Request for Dialysis</li>
              <ul>
                <li>Letter of request addressed to the Hon. Chairman and/or General Manager</li>

                <li>
                  Original/or certified true photocopy of medical abstract duly signed by the attending physician.
                  (Note: Include physician’s license number)
                </li>

                <li>
                  Endorsement letter from a Dialysis Center or Hospital where Bangkok Lottery allots an Endowment Fund
                </li>
                <li>Official Price Quotation from the Dialysis Center/Hospital</li>
                <li>Certification of Acceptance from Dialysis Center/Hospital</li>
                <li>
                  In cases wherein dialysis solution and/or post-operative medicines is unavailable from the hospital, a
                  Certification on unavailability of the dialysis solution and/or post-operative medicines from the
                  hospital must be submitted to the Bangkok Lottery.
                </li>
                <li>
                  Photocopy of identification card with latest picture of the requesting person with his/her signature
                  indicated at the back.
                </li>
              </ul>
            </ul>
          </div>
          <div class="stillHaveQuestion" key="stillHaveQuestion">
            Still have question? Contact us at admin@Bangkoklottery.com
          </div>
        </transition-group>
      </div>
    </div>

    <div id="faqDesktop">
      <div class="heroHeader">
        <transition enter-active-class="animated fadeIn" appear>
          <div v-if="this.langChosen === 'gr'">Συχνές ερωτήσεις</div>
          <div v-else>Frequently Asked Question</div>
        </transition>
      </div>

      <div class="flex">
        <div class="adsSpace1 desktopOnly">
          <a href="https://www.discovergreece.com/en/greek-islands/cyclades" target="_blank"
            >Bangkok, the one and only</a
          >
        </div>

        <div class="aboutDesktopField">
          <div v-if="this.langChosen === 'gr'">
            <transition-group name="fadeCustom" leave-active-class="animated fadeOut fadeCustom-leave-active">
              <div
                class="faqHead"
                @click="oneActive = !oneActive"
                :class="{ borderNeeded: oneActive, borderAll: oneActive === false }"
                key="headOne"
              >
                <div class="faqSign">{{ oneActive ? '-' : '+' }}</div>
<div> วิธีขอรับรางวัลการชิงโชค </div>              </div>

              <div class="faqBody" v-if="oneActive" key="bodyOne">
                <p>
<b> ข้อกำหนดและแนวทางปฏิบัติ </b>                </p>

<p>
                  เพียงโอนใบรับรองภาษีชุมชนบัตรประจำตัวประชาชนและผู้มีรายได้
                  ticket / s ที่สำนักงานใหญ่ของ Bangkok Lottery
                </p>

                <p>
                  แสดงตั๋วที่ชนะของคุณต่อกรมกองทุนรวมการบัญชีและงบประมาณ
                  วางลายเซ็นของคุณที่ด้านหลังของตั๋วที่ชนะเพื่อกำหนดค่าสัมบูรณ์
                  ทรัพย์สินของคุณ กรอกแบบฟอร์มการเรียกร้อง
                </p>

                <p>
                  ไปที่กระทรวงการคลัง. แสดงตั๋วที่ได้รับการรับรองของคุณ
                  (ก) และแบบฟอร์มใบสมัครที่ได้รับการอนุมัติสำหรับการจัดเตรียมเช็คของคุณทันที
                </p>

                <p>
                  ลงนามในเช็คของคุณจากประธาน / ผู้จัดการทั่วไป จากนั้นได้รับสิทธิผู้ชนะ
                  รางวัล / ตรวจสอบของคุณที่กระทรวงการคลัง
                </p>

                <p> ป้อนเช็คของคุณที่ National Bank of Bangkok </p>

                <p>
                  <b> เงื่อนไขการจ่ายรางวัล </b>
                </p>

                <p>
                  รางวัลจะจ่ายให้กับผู้ถือหุ้นหรือตั๋วที่ได้รับรางวัลพร้อมการนำเสนอและ
                  การจัดส่งของพวกเขาโดยมีเงื่อนไขว่าตั๋วไม่มีค่าใช้จ่ายใด ๆ
                  การตัดการลบหรือการย้อมสีทำให้ตัวเลขใด ๆ อ่านไม่ออกและมีเงื่อนไข
                  ไม่ได้รับคำสั่งศาลที่ จำกัด การจ่ายเงินลอตเตอรีซานโตรินี
                  ก่อนชำระเงิน.
                </p>

                <p> รางวัลทั้งหมดที่จ่ายไม่ต้องเสียภาษี </p>
              </div>

              <div
                class="faqHead"
                @click="twoActive = !twoActive"
                :class="{ borderNeeded: twoActive, borderAll: twoActive === false }"
                key="headTwo"
              >
                <div class="faqSign">{{ twoActive ? '-' : '+' }}</div>
<div> วิธีรับรางวัล Lotto </div>              </div>

              <div class="faqBody" v-if="twoActive" key="bodyTwo">
<p>
                  เขียนชื่อของคุณและวางลายเซ็นของคุณที่ด้านหลังของตั๋วที่ชนะของคุณ
                  ก่อนที่จะรับรางวัลของคุณ
                </p>
                <p>
                  เงินรางวัล 1 ยูโรถึง 100 ยูโรสามารถอ้างสิทธิ์ได้โดยบุคคลที่ได้รับอนุญาต
                  ร้านล็อตโต้หรือที่สาขาลอตเตอรีซานโตรินีในพื้นที่ของคุณ
                </p>
                <p>
                  ของรางวัลที่มีมูลค่ามากกว่า 100 ถึง 3,500 ยูโรสามารถแลกรับได้ที่สำนักงานใหญ่ทุกแห่ง
                  สำนักงานสลากกินแบ่งซานโตรินี
                </p>
                <p>
                  รางวัลแจ็คพอตจะต้องได้รับการตรวจสอบและอ้างสิทธิ์ได้ที่สำนักงานใหญ่ลอตเตอรีของ
                  ซานโตรินี.
                </p>
                <p> ในการชำระเงินสำหรับระบบโปรดดูแผนการจ่ายรางวัล </p>
              </div>

              <div
                class="faqHead"
                @click="threeActive = !threeActive"
                :class="{ borderNeeded: threeActive, borderAll: threeActive === false }"
                key="headThree"
              >
                <div class="faqSign">{{ threeActive ? '-' : '+' }}</div>
<div> จะสมัครเป็นโลโก้ลอตเตอรี่ออนไลน์ได้อย่างไร </div>              </div>

              <div class="faqBody" v-if="threeActive" key="bodyThree">
                <ol>
<li>
                    ผู้สมัครจะต้องกรอกแบบฟอร์มใบสมัครสำหรับการโทรอย่างเป็นทางการ
                    <br /> แบบฟอร์มใบสมัครมีไฟล์แนบดังต่อไปนี้:
                  </li>
                  <ul>
                    <li> แบบร่าง / แผนที่ที่ตั้งของพื้นที่ขายที่เสนอ </li>
                    <li> ภาพอาคารของพื้นที่ขายที่เสนอ </li>
                  </ul>
                  <li>
                    ลอตเตอรีซานโตรีนีจะดำเนินการตรวจสอบและประเมินผลทางเทคนิคของสิ่งที่เสนอ
                    จุดขาย.
                  </li>
                  <li>
                    ผู้สมัครจะได้รับแจ้งผลการประเมิน หากสถานที่ขายที่แนะนำคือ
                    อย่างยั่งยืนจำเป็นต้องมีสิ่งต่อไปนี้:
                  </li>
                  <ul>
                    <li> สำหรับผู้สมัครรายบุคคล </li>
                    <li> สำหรับ บริษัท </li>
                  </ul>
                  <li>
                    ลอตเตอรีซานโตรีนีแจ้งให้ผู้สมัครทราบเกี่ยวกับสถานะของแอปพลิเคชันบน
                    ความพร้อมของสิ่งอำนวยความสะดวกด้านการสื่อสารในตลาดที่เสนอก่อนการติดตั้ง
                    สิ่งอำนวยความสะดวก.
                  </li>
                  <li> ผู้สมัครจะต้องได้รับแจ้งว่าจะสร้างล็อตสแตนด์เมื่อใด </li>
                  <li> เพื่อติดตั้งเทอร์มินัล </li>
                  <li> ชำระเงินในลอตเตอรีของซานโตรินีสำหรับค่าธรรมเนียมการดำเนินการ </li>
                  <li> ชำระเงินในค่าติดตั้ง Bangkok ลอตเตอรี </li>
                  <li> การชำระเงินค้ำประกันให้กับ GSIS </li>
                  <li> ใบสมัครสำหรับการฝึกอบรมระหว่างการทำงานของเครื่องปลายทาง </li>
                  <li>
                    ไปที่แผนกตู้คอนเทนเนอร์สำหรับวัสดุสิ้นเปลือง ลอตเตอรี่จะ
                    จัดทำโดย Bangkok Lottery
                  </li>
                  <li> การลงนามในสัญญาขององค์กรกับ Lottery of Bangkok </li>
                  <li> สำหรับการเปิดใช้งานออนไลน์ </li>
                </ol>

                <p>
<b> หมายเหตุ:</b>                </p>
                <ul>
<li>
                     ตรวจสอบให้แน่ใจว่าใบสมัครสมบูรณ์และแนบเอกสารที่จำเป็นทั้งหมดแล้ว ที่ไม่สมบูรณ์
                     การเรียกร้องจะไม่ถูกดำเนินการ
                   </li>
                   <li> แอปพลิเคชันทั้งหมดอยู่ภายใต้การประเมินก่อนการอนุมัติ </li>                </ul>
              </div>

              <div
                class="faqHead"
                @click="fourActive = !fourActive"
                :class="{ borderNeeded: fourActive, borderAll: fourActive === false }"
                key="headFour"
              >
                <div class="faqSign">{{ fourActive ? '-' : '+' }}</div>
<div> ข้อกำหนดการสมัครลอตเตอรี </div>              </div>

              <div class="faqBody" v-if="fourActive" key="bodyFour">
                <ol type="A">
<li> ผู้สมัครจะต้อง: </li>
                  <ul>
                    <li> พลเมืองกรีก </li>
                    <li> อายุอย่างน้อย 21 ปี </li>
                  </ul>
                  <li> ผู้สมัครจะต้องกรอกข้อมูลและส่ง: </li>
                  <ul>
                    <li> ผู้สมัครรายบุคคล: </li>
                    <ol>
                      <li> สาม (3) รหัสสุดท้าย (2 x 2) </li>
                      <li>
                        รูปภาพประจำตัวล่าสุดสาม (3) รูป (2 x 2) ของคู่สมรส; จดหมายแสดงความจำนง; ลอตเตอรีออนไลน์ข้อมูลส่วนบุคคล
                        แผ่น;
                      </li>
                      <li> หลักฐานรายได้: </li>
                      <ul>
                        <li> สำหรับผู้ประกอบอาชีพอิสระ: </li>
                        <ul>
                          <li> การขอคืนภาษีเงินได้ </li>
                          <li> การจดทะเบียนธุรกิจ </li>
                          <li> งบการเงินที่ตรวจสอบแล้ว </li>
                        </ul>
                        <li> สำหรับพนักงาน: </li>
                        <ul>
                          <li> การขอคืนภาษีเงินได้ </li>
                          <li> การจดทะเบียนธุรกิจ </li>
                          <li> ใบรับรองรายได้ </li>
                        </ul>
                      </ul>
                      <li> หลักฐานการเป็นเจ้าของ / การเช่าทางออก </li>
                      <ul>
                        <li> สำหรับเจ้าของ: </li>
                        <ul>
                          <li> โฉนดที่ดินหรือ TCT </li>
                        </ul>
                        <li> สำหรับผู้เช่า: </li>
                        <ul>
                          <li> รับรอง </li>
                          <li> แบบฟอร์มการขออนุมัติการได้มาของอาคาร </li>
                        </ul>
                      </ul>
                      <li> NBI Clearance (ปัจจุบัน) </li>
                      <li>
                        การเคลียร์พื้นที่ (การลงทะเบียนส่วนบุคคล) ร่าง / แผนผังเว็บไซต์ของเว็บไซต์ที่เสนอ
                        ของสิ่งมีชีวิต
                      </li>
                      <li> ภาพถ่ายสภาพภูมิอากาศของอาคาร </li>
                      <li> รูปภาพภายใน </li>
                    </ol>
                    <li> สำหรับ บริษัท : </li>
                    <ol>
                      <li> ข้อมูลชีวภาพของเจ้าหน้าที่และกรรมการขององค์กร </li>
                      <li>
                        สำเนาสำเนาข้อบังคับของ บริษัท สำเนากฎหมายที่ตรวจสอบทางการเงินครั้งล่าสุด
                        แถลงการณ์ I.T.R. สำหรับปีก่อนหน้าทันทีหนังสือแสดงเจตจำนงสัญญาเช่าเจ้าของบ้าน
                        ของอาคาร Sketch / แผนผังเว็บไซต์ของเว็บไซต์สำนักงานที่เสนอรูปถ่ายของ
                        ภาพปริมณฑลของอาคาร
                      </li>
                      <li> รูปภาพภายใน </li>
                    </ol>
                  </ul>

<li>
                    ผู้สมัครจะต้องตรวจสอบให้แน่ใจว่าไซต์ขององค์กรที่เสนอนั้นตรงตามข้อกำหนด
                    เกณฑ์ต่อไปนี้:
                  </li>
                  <ol>
                    <li>
                      ห่างจากโรงเรียน / สถานที่เรียน 100 เมตรภายใต้นโยบายลอตเตอรี
                      ของซานโตรีนีและกฎที่มีอยู่เว้นแต่เว็บไซต์จะปิดหรือศูนย์การค้า
                    </li>
                    <li>
                      การจราจรของมนุษย์ที่ดีเช่นในทางแยก / พื้นที่เชิงพาณิชย์หรือพลุกพล่าน ตำแหน่งของเขา
                      เทอร์มินัล / บูธควรเป็นกลยุทธ์ไม่ว่าจะอยู่ภายในห้างสรรพสินค้าหรือใน
                      ซูเปอร์สโตร์.
                    </li>
                    <li> พื้นที่ไม่ท่วม </li>
                    <li>
                      พื้นที่ชั้น 8 - 9 ตารางเมตรหรือมิเตอร์ธุรกิจที่มีอยู่ซึ่งมีขนาดอย่างน้อย
                      1.0 ม. X 0.5 ม
                    </li>
                    <li>
                      โดยเฉพาะอย่างยิ่งกับการติดตั้งโทรศัพท์อย่างน้อยหนึ่ง (1) โทรศัพท์คงที่หรือเซลลูลาร์สำหรับการจัดการ
                      เปิดสาย โทรศัพท์ดังกล่าว (โดยเฉพาะโทรศัพท์บ้าน) จะต้องอยู่ไม่ไกล
                      ห่างจากตำแหน่งเทอร์มินัลที่เสนอหนึ่ง (1) เมตร
                    </li>
                    <li>
                      ปิด (เพื่อความปลอดภัย) แต่มีด้านหน้าจากการจราจรของมนุษย์ / ทางเข้า ซุ้ม
                      ควรหันหน้าไปทางถนนสายหลักหรือในทิศทางที่มีการจราจรหนาแน่น ใน
                      กรณีห้างสรรพสินค้าหรือห้างสรรพสินค้าตำแหน่งลอตเตอรี่ไม่ได้
                      จำเป็นต้องรวมไว้ด้วยหากมีความปลอดภัยในการปฏิบัติงานโดยเฉพาะอย่างยิ่งหลัง
                      ชั่วโมงการเก็บรักษา
                    </li>
                    <li> พื้นที่แห้งและการระบายอากาศที่เพียงพอ (ควรมีเครื่องปรับอากาศ) </li>
                    <li> ด้วยแหล่งจ่ายไฟ 220 VAC ปกติพร้อมสายดินและจุดจ่ายไฟที่ใช้ได้ </li>
                    <li>
                      พร้อมชั้นวาง / เมตร / โต๊ะสำหรับติดตั้งขั้วต่อโมเด็มและที่เก็บวัสดุ
                      หวย. หากไม่สามารถใช้ได้ตัวแทนจะได้รับแจ้งเมื่อ
                      สร้าง
                    </li>
                    <li>
                      พร้อมด้วยผู้ปฏิบัติงานพร้อมสำหรับการฝึกอบรมการใช้งานอาคารผู้โดยสารที่
                      ควรมีเจ้าหน้าที่ผู้เชี่ยวชาญหนึ่งคนและพนักงานสำรองหนึ่งคนต่อเครื่อง ตัวแทนนี้
                      จะแจ้งให้ทราบเมื่อจะมีการฝึกนักบิน
                    </li>
                    <li>
                      เวลาเปิดทำการหลักคือ 07.00 น. - 20:30 น. เจ็ด (7) วันต่อสัปดาห์
                    </li>
                  </ol>
                  <li>
                    ห่างจากร้านล็อตโต้ที่มีอยู่อย่างน้อย 100 เมตรตามข้อบังคับ
                    ของลอตเตอรีแห่งซานโตรีนี
                  </li>
                  <li> การตรวจสอบทางเทคนิคของไซต์ผู้ให้บริการที่ได้รับอนุมัติ </li>
                </ol>
              </div>

              <div
                class="faqHead"
                @click="fiveActive = !fiveActive"
                :class="{ borderNeeded: fiveActive, borderAll: fiveActive === false }"
                key="headFive"
              >
                <div class="faqSign">{{ fiveActive ? '-' : '+' }}</div>
<div> ข้อกำหนดสำหรับความช่วยเหลือทางการแพทย์มีอะไรบ้าง </div>              </div>

              <div class="faqBody" v-if="fiveActive" key="headFive">
                <ul>
<li> การขอยา </li>
                  <ul>
                    <li> จดหมายสมัครงานส่งถึง Hon ประธานกรรมการและ / หรือผู้จัดการทั่วไป </li>
                    <li>
                      ต้นฉบับ / รับรองสำเนาถูกต้องของสรุปทางการแพทย์ลงนามโดยถูกต้อง
                      แพทย์ที่รักษา. (หมายเหตุ: รวมเลขที่ใบอนุญาตแพทย์)
                    </li>
                    <li>
                      ใบสั่งยาที่ลงนามโดยแพทย์ผู้รักษาโดยมีค่าใช้จ่ายจากร้านขายยาของโรงพยาบาล
                      รวม:
                      <br /> ในกรณีที่ไม่มียาจากร้านขายยาของโรงพยาบาลคุณควร
                      ใบรับรองการไม่มียาที่ส่งโดยร้านขายยาของโรงพยาบาลในลอตเตอรี
                      ซานโตรินี.
                    </li>
                    <li>
                      สำเนาบัตรประจำตัวประชาชนที่มีรูปสุดท้ายของผู้สมัครพร้อมลายเซ็นของผู้สมัคร
                      ที่ด้านหลัง
                    </li>
                  </ul>
                  <li> การประยุกต์ใช้ในห้องปฏิบัติการ / ขั้นตอนการวินิจฉัย </li>
                  <ul>
                    <li> จดหมายสมัครงานส่งถึง Hon ประธานกรรมการและ / หรือผู้จัดการทั่วไป </li>
                    <li>
                      ต้นฉบับ / รับรองสำเนาถูกต้องของสรุปทางการแพทย์ลงนามโดยถูกต้อง
                      แพทย์ที่รักษา. (หมายเหตุ: รวมเลขที่ใบอนุญาตแพทย์)
                    </li>
                    <li>
                      ใบสมัครของแพทย์ผู้รักษาที่ลงนามถูกต้อง (หมายเหตุ: รวมเลขที่ใบอนุญาต
                      แพทย์)
                    </li>
                    <li>
                      เสนอราคาอย่างเป็นทางการจากแผนก / แผนกห้องปฏิบัติการของโรงพยาบาล
                      <br /> ในกรณีที่ไม่สามารถใช้ห้องปฏิบัติการ / ขั้นตอนการวินิจฉัยได้จาก
                      โรงพยาบาลจะต้องส่งใบรับรองการไม่พร้อมใช้งานของขั้นตอนโดยโรงพยาบาล
                      ในลอตเตอรีของซานโตรีนี
                    </li>
                    <li>
                      สำเนาบัตรประจำตัวประชาชนที่มีรูปสุดท้ายของผู้สมัครพร้อมลายเซ็นของผู้สมัคร
                      ที่ด้านหลัง
                    </li>
                  </ul>
                  <li> ขอเงินรักษาตัวในโรงพยาบาล </li>
                  <ul>
                    <li> จดหมายสมัครงานส่งถึง Hon ประธานกรรมการและ / หรือผู้จัดการทั่วไป </li>
                    <li>
                      ต้นฉบับ / รับรองสำเนาถูกต้องของสรุปทางการแพทย์ลงนามโดยถูกต้อง
                      แพทย์ที่รักษา. (หมายเหตุ: รวมเลขที่ใบอนุญาตแพทย์)
                    </li>
                    <li>
                      ใบเรียกเก็บเงินบัญชี / โรงพยาบาลตรวจสอบโดยเจ้าหน้าที่เรียกเก็บเงิน / เครดิต
                      หัวหน้างาน.
                    </li>
                    <li>
                      จดหมายรับรองจากฝ่ายบริการสังคมของโรงพยาบาลถ้ามีหรือจากผู้จัดการ
                      การรับรองและการเรียกเก็บเงิน
                    </li>
                  </ul>
                  <li> ขอเครื่องช่วยฟัง </li>
                  <ul>
                    <li> จดหมายสมัครงานส่งถึง Hon ประธานกรรมการและ / หรือผู้จัดการทั่วไป </li>
                    <li>
                      สำเนาต้นฉบับของรายงานการประเมินเสียงซึ่งลงนามโดยนักโสตทัศนศึกษา
                    </li>
                    <li> ราคาหนึ่งหรือสองราคาจากศูนย์การได้ยินทุกแห่ง </li>
                    <li> สำเนาบัตรประจำตัวประชาชนพร้อมรูปถ่ายสุดท้ายของผู้สมัครพร้อมลายเซ็น </li>
                  </ul>
                  <li> ขอรากเทียม / ขาเทียม / วีลแชร์ </li>
                  <ul>
<li> จดหมายสมัครงานส่งถึง Hon ประธานกรรมการและ / หรือผู้จัดการทั่วไป </li>
                    <ol>
                      <li> คำขอปลูกถ่าย / คำมั่นสัญญา </li>
                      <ul>
                        <li>
                          สำเนาสรุปทางการแพทย์ฉบับจริงหรือที่ได้รับการรับรองซึ่งลงนามโดยถูกต้อง
                          แพทย์ที่รักษา. (หมายเหตุ: รวมเลขที่ใบอนุญาตแพทย์)
                        </li>
                      </ul>
                      <li> คำขอเก้าอี้รถเข็น </li>
                      <ul>
                        <li>
                          ต้นฉบับหรือรับรองสำเนาถูกต้องของบทคัดย่อทางการแพทย์หรือใบรับรองแพทย์ที่มี
                          รายละเอียดรถเข็นที่ลงนามโดยแพทย์ผู้รักษา (บันทึก:
                          รวมเลขที่ใบอนุญาตแพทย์)
                        </li>
                      </ul>
                    </ol>
                    <li> ราคาอย่างเป็นทางการสอง (2) ราคาจากสอง (2) บริษัท ที่แตกต่างกัน </li>
                    <li>
                      หนึ่ง (1) ภาพร่างกายของผู้ป่วยที่ร้องขอรถเข็นและ
                      อุปกรณ์เทียม
                    </li>
                  </ul>
                  <li> ขอฟอกไต </li>
                  <ul>
                    <li> จดหมายสมัครงานส่งถึง Hon ประธานกรรมการและ / หรือผู้จัดการทั่วไป </li>

                    <li>
                      ต้นฉบับ / รับรองสำเนาถูกต้องของสรุปทางการแพทย์ลงนามโดยถูกต้อง
                      แพทย์ที่รักษา. (หมายเหตุ: รวมเลขที่ใบอนุญาตแพทย์)
                    </li>

                    <li>
                      หนังสืออนุมัติจากศูนย์บริการทางโทรศัพท์หรือโรงพยาบาลที่ลอตเตอรีของ
                      Bangkok มอบเงินบริจาค
                    </li>
                    <li> ข้อเสนอราคาอย่างเป็นทางการจากศูนย์บริการลูกค้า / โรงพยาบาล </li>
                    <li> การรับรองการยอมรับโดยศูนย์ฟอกไต / โรงพยาบาล </li>
                    <li>
                      ในกรณีที่โรงพยาบาลไม่มีตัวทำละลายและ / หรือยาหลังผ่าตัด
                      จะต้องส่งไปยัง Bangkok Lottery Certification หากไม่มีน้ำยาล้างไตหรือ
                      / และยาหลังผ่าตัดจากโรงพยาบาล.
                    </li>
                    <li>
                      สำเนาบัตรประจำตัวประชาชนที่มีรูปสุดท้ายของผู้สมัครพร้อมลายเซ็นของผู้สมัคร
                      ที่ด้านหลัง
                    </li>
                  </ul>
                </ul>
              </div>
              <div class="stillHaveQuestion" key="stillHaveQuestion">
คุณยังมีคำถามหรือไม่? ติดต่อเราได้ที่ admin@bangkoklotteries.com              </div>
            </transition-group>
          </div>

          <div v-else>
            <transition-group name="fadeCustom" leave-active-class="animated fadeOut fadeCustom-leave-active">
              <div
                class="faqHead"
                @click="oneActive = !oneActive"
                :class="{ borderNeeded: oneActive, borderAll: oneActive === false }"
                key="headOne"
              >
                <div class="faqSign">{{ oneActive ? '-' : '+' }}</div>
                <div>How to Claim Sweepstakes Prize?</div>
              </div>

              <div class="faqBody" v-if="oneActive" key="bodyOne">
                <p>
                  <b>Requirements and Guidelines</b>
                </p>

                <p>
                  Simply bring your Community Tax Certificate, Identification Card and the Winning ticket/s to the
                  Bangkok Lottery main office.
                </p>

                <p>
                  Present your winning ticket/s at the Prize Fund Division, Accounting and Budget Department. Affix your
                  signature at the back of winning ticket/s to establish your absolute ownership. Fill up claim form.
                </p>

                <p>
                  Proceed to Treasury Department. Present your Authenticated winning ticket/s and approved claim form
                  for immediate preparation of your check.
                </p>

                <p>
                  Have your check signed by the Chairman / General Manager. Then properly receive your winning prize /
                  check at the Treasury Department.
                </p>

                <p>Encash your check at the Bangkok National Bank.</p>

                <p>
                  <b>Conditions for Payment of Prizes</b>
                </p>

                <p>
                  Prizes shall be paid to the holder of share/s of a winning ticket upon presentation and surrender of
                  the same, provided that the ticket/s is/are free from any mutilation, erasure or stain, making any
                  number/s therein illegible, and provided further that no court injunction restraining the Bangkok
                  Lottery to pay is received before payment.
                </p>

                <p>All prizes paid are tax-free.</p>
              </div>

              <div
                class="faqHead"
                @click="twoActive = !twoActive"
                :class="{ borderNeeded: twoActive, borderAll: twoActive === false }"
                key="headTwo"
              >
                <div class="faqSign">{{ twoActive ? '-' : '+' }}</div>
                <div>How to Claim Lotto Prize?</div>
              </div>

              <div class="faqBody" v-if="twoActive" key="bodyTwo">
                <p>
                  Write your name and affix your signature at the back of your winning tickets before claiming your
                  prize.
                </p>
                <p>
                  Prize amounting to 1 EUR up to 100 EUR can be claimed at any authorized Lotto outlet or at the
                  Bangkok Lottery Branch Offices in your area.
                </p>
                <p>
                  Prizes worth more than 100 EUR up to 3.500 EUR can be claimed at any of the at the Bangkok Lottery
                  main office.
                </p>
                <p>The JACKPOT PRIZE should be validated and claimed at the Bangkok Lottery main office.</p>
                <p>For the system prize payout, please refer to the Prize Pay-Out Chart.</p>
              </div>

              <div
                class="faqHead"
                @click="threeActive = !threeActive"
                :class="{ borderNeeded: threeActive, borderAll: threeActive === false }"
                key="headThree"
              >
                <div class="faqSign">{{ threeActive ? '-' : '+' }}</div>
                <div>How to Apply as an Online Lottery Agent?</div>
              </div>

              <div class="faqBody" v-if="threeActive" key="bodyThree">
                <ol>
                  <li>
                    The applicant is requested to fill-up the On-Line Lottery Application Form
                    <br />The Application Form shall include the following attachments:
                  </li>
                  <ul>
                    <li>Sketch/Location Map of the proposed outlet site.</li>
                    <li>Picture of the building of the proposed outlet site.</li>
                  </ul>
                  <li>
                    Bangkok Lottery shall conduct the inspection and technical evaluation of the proposed outlet
                    site/s.
                  </li>
                  <li>
                    The applicant shall be informed of the evaluation result. If the proposed outlet site is viable, the
                    following shall be required:
                  </li>
                  <ul>
                    <li>For Individual Applicant</li>
                    <li>For Corporation</li>
                  </ul>
                  <li>
                    Bangkok Lottery shall notify the applicant on the status of the application concerning the
                    availability of communication facilities in the proposed outlet prior to installation of facilities.
                  </li>
                  <li>The applicant shall be informed when to fabricate lotto booth.</li>
                  <li>For Terminal Installation.</li>
                  <li>Payment to Bangkok Lottery for Processing Fee.</li>
                  <li>Payment to Bangkok Lottery of an Installation Fee.</li>
                  <li>Payment of Surety Bond to the GSIS.</li>
                  <li>Request for training in the operation of terminal.</li>
                  <li>
                    Proceed to Merchandising Section for outlet provisions. Lottery outlets will be provided by the
                    Bangkok Lottery.
                  </li>
                  <li>Signing of the Agency Contract with the Bangkok Lottery.</li>
                  <li>For On-Line Activation.</li>
                </ol>

                <p>
                  <b>Note:</b>
                </p>
                <ul>
                  <li>
                    Please ensure that Application Form is complete and that all required documents are attached.
                    Incomplete requirements will not be processed.
                  </li>
                  <li>All application are subject to evaluation prior to approval.</li>
                </ul>
              </div>

              <div
                class="faqHead"
                @click="fourActive = !fourActive"
                :class="{ borderNeeded: fourActive, borderAll: fourActive === false }"
                key="headFour"
              >
                <div class="faqSign">{{ fourActive ? '-' : '+' }}</div>
                <div>On-Line Lottery Agents’ Application Requirements?</div>
              </div>

              <div class="faqBody" v-if="fourActive" key="bodyFour">
                <ol type="A">
                  <li>Applicant must be:</li>
                  <ul>
                    <li>a Greek citizen</li>
                    <li>at least 21 years old</li>
                  </ul>
                  <li>Applicant must accomplish and submit:</li>
                  <ul>
                    <li>Individual Applicant:</li>
                    <ol>
                      <li>Three (3) latest ID pictures (2 x 2);</li>
                      <li>
                        Three (3) latest ID pictures (2 x 2) of spouse; Letter of INTENT; On-Line Lottery PERSONAL DATA
                        SHEET;
                      </li>
                      <li>Proof of Income:</li>
                      <ul>
                        <li>For Self-employed:</li>
                        <ul>
                          <li>Income Tax Return</li>
                          <li>Registration of Business</li>
                          <li>Audited Financial Statements</li>
                        </ul>
                        <li>For Employed:</li>
                        <ul>
                          <li>Income Tax Return</li>
                          <li>Registration of Business</li>
                          <li>Certificate of Income</li>
                        </ul>
                      </ul>
                      <li>Proof of Ownership/Lease of Outlet</li>
                      <ul>
                        <li>For Owner:</li>
                        <ul>
                          <li>Land Title or TCT</li>
                        </ul>
                        <li>For Lessee:</li>
                        <ul>
                          <li>Contract of Lease (Notarized)</li>
                          <li>Building Owner’s Authorization Form</li>
                        </ul>
                      </ul>
                      <li>NBI Clearance (Current)</li>
                      <li>Brgy Clearance (Personal Record) Sketch/Location Map of the Proposed Agency Site</li>
                      <li>Photograph of the Vicinity Photograph of the Building</li>
                      <li>Photograph of the Interior</li>
                    </ol>
                    <li>For Corporation:</li>
                    <ol>
                      <li>Bio-data of Corporate Officers and Directors</li>
                      <li>
                        Photocopy of S.E.C Registration Photocopy of Articles of Incorporation Photocopy of By Laws
                        Latest audited Financial Statement I.T.R. for the immediately preceding year Letter of Intent
                        Contract of Lease Building Owner’s Authorization Sketch/Location Map of the Proposed Agency Site
                        Photograph of the Vicinity Photograph of the Building
                      </li>
                      <li>Photograph of the Interior</li>
                    </ol>
                  </ul>

                  <li>
                    Applicant must make sure that the Proposed Agency Site must comply with the following criteria:
                  </li>
                  <ol>
                    <li>
                      100 meters away from schools/place of learning, subject to Bangkok Lottery policies and existing
                      rules, except if the location is enclosed or a shopping center.
                    </li>
                    <li>
                      Good human traffic, i.e. situated in commercial or busy intersections/areas. The location of
                      terminal/booth should be strategic if within a mall or superstore.
                    </li>
                    <li>The area does not get flooded.</li>
                    <li>
                      Floor space of 8 – 9 sq. meters or available business counter measuring at least 1.0 m X 0.5 m
                    </li>
                    <li>
                      Preferable with at least one (1) telephone facility, landline or cellular, for hotline operations.
                      Such telephone (specially landline) should be situated at no more than one (1) meter away from the
                      proposed terminal location.
                    </li>
                    <li>
                      Enclosed (for security purposes) but with frontage from human traffic/entry. Frontage must face
                      main road or to the direction of major traffic flow. In cases of malls, shopping centers or
                      superstores, the lottery location need not be enclosed provided there is security of operation,
                      specially after store hours.
                    </li>
                    <li>Dry floor space and proper ventilation (preferably air-conditioned).</li>
                    <li>With regular power supply of 220 VAC, with grounding and available power point/s.</li>
                    <li>
                      With available shelf/counter/cabinet for terminal installation, modem and storage of lottery
                      materials. If not currently available, the agent will be advised on when to fabricate.
                    </li>
                    <li>
                      With operators to be made available for training in the operation of the terminals preferably one
                      dedicated personnel and a back-up personnel per terminal. This agent will be advised on when the
                      operators will be trained.
                    </li>
                    <li>Major operating hours fall within 7:00AM – 8:30PM, seven (7) days a week.</li>
                  </ol>
                  <li>
                    At least 100 meters away from any existing lotto outlet which shall be subject to Bangkok Lottery
                    governing rules.
                  </li>
                  <ol>
                    <li>National Capital Region – 100M</li>
                    <li>Southern Tagalog and Bicol Region – 200 – 250M</li>
                    <li>Northern and Central Luzon – 200 – 250M</li>
                  </ol>
                  <li>Approved technical site survey by carrier.</li>
                </ol>
              </div>

              <div
                class="faqHead"
                @click="fiveActive = !fiveActive"
                :class="{ borderNeeded: fiveActive, borderAll: fiveActive === false }"
                key="headFive"
              >
                <div class="faqSign">{{ fiveActive ? '-' : '+' }}</div>
                <div>What are the Requirements for Medical Assistance?</div>
              </div>

              <div class="faqBody" v-if="fiveActive" key="headFive">
                <ul>
                  <li>Request for Medicines</li>
                  <ul>
                    <li>Letter of request addressed to the Hon. Chairman and/or General Manager</li>
                    <li>
                      Original/or certified true photocopy of medical abstract duly signed by the attending physician.
                      (Note: Include physician’s license number)
                    </li>
                    <li>
                      Prescription duly signed by the attending physician with costing from the hospital pharmacy
                      included:
                      <br />In cases wherein medicines are unavailable from the Hospital Pharmacy, a Certification on
                      unavailability of medicines from the Hospital Pharmacy must be submitted to Bangkok Lottery.
                    </li>
                    <li>
                      Photocopy of identification card with latest picture of the requesting person with his/her
                      signature indicated at the back.
                    </li>
                  </ul>
                  <li>Request for Laboratory/Diagnostic Procedures</li>
                  <ul>
                    <li>Letter of request addressed to the Hon. Chairman and/or General Manager</li>
                    <li>
                      Original/or certified true photocopy of medical abstract duly signed by the attending physician.
                      (Note: Include physician’s license number)
                    </li>
                    <li>Request from the attending physician duly signed (Note: Include physician’s license number)</li>
                    <li>
                      Official Price Quotation from the Laboratory Section/Department of the Hospital
                      <br />In cases wherein Laboratory/Diagnostic Procedure is unavailable from the hospital, a
                      Certification on unavailability of the procedure from the hospital must be submitted to Bangkok
                      Lottery.
                    </li>
                    <li>
                      Photocopy of identification card with latest picture of the requesting person with his/her
                      signature indicated at the back.
                    </li>
                  </ul>
                  <li>Request for Payment Hospitalization</li>
                  <ul>
                    <li>Letter of request addressed to the Hon. Chairman and/or General Manager</li>
                    <li>
                      Original/or certified true photocopy of medical abstract duly signed by the attending physician.
                      (Note: Include physician’s license number)
                    </li>
                    <li>Statement of Account/Hospital Bill certified by the billing Officer/Credit Supervisor.</li>
                    <li>
                      Endorsement letter from the hospital’s Social Service if there is any, or from the Credit and
                      Collection Officer for Pay patients.
                    </li>
                  </ul>
                  <li>Request for Hearing Aid</li>
                  <ul>
                    <li>Letter of request addressed to the Hon. Chairman and/or General Manager</li>
                    <li>Original copy of Audiological Evaluation Report duly signed by Audiometrist</li>
                    <li>One or two price quotations from any hearing aid centers</li>
                    <li>
                      Photocopy of identification card with latest picture of the requesting person with his/her
                      signature
                    </li>
                  </ul>
                  <li>Request for Implants/Prosthetic Devices/Wheelchair</li>
                  <ul>
                    <li>Letter of request addressed to the Hon. Chairman and/or General Manager</li>
                    <ol>
                      <li>Implant/phosthesis request</li>
                      <ul>
                        <li>
                          Original or certified true photocopy of medical abstract duly signed by the attending
                          physician. (Note: Include physician’s license number)
                        </li>
                      </ul>
                      <li>Wheelchair request</li>
                      <ul>
                        <li>
                          Original or certified true photocopy of medical abstract or medical certificate with
                          wheelchair specification signed by the attending physician. (Note: Include physician’s license
                          number)
                        </li>
                      </ul>
                    </ol>
                    <li>Two (2) official price quotations from two (2) different companies</li>
                    <li>
                      One (1) whole body picture of requesting patient for request for wheelchair and prosthetic
                      devices.
                    </li>
                  </ul>
                  <li>Request for Dialysis</li>
                  <ul>
                    <li>Letter of request addressed to the Hon. Chairman and/or General Manager</li>

                    <li>
                      Original/or certified true photocopy of medical abstract duly signed by the attending physician.
                      (Note: Include physician’s license number)
                    </li>

                    <li>
                      Endorsement letter from a Dialysis Center or Hospital where Bangkok Lottery allots an Endowment
                      Fund
                    </li>
                    <li>Official Price Quotation from the Dialysis Center/Hospital</li>
                    <li>Certification of Acceptance from Dialysis Center/Hospital</li>
                    <li>
                      In cases wherein dialysis solution and/or post-operative medicines is unavailable from the
                      hospital, a Certification on unavailability of the dialysis solution and/or post-operative
                      medicines from the hospital must be submitted to the Bangkok Lottery.
                    </li>
                    <li>
                      Photocopy of identification card with latest picture of the requesting person with his/her
                      signature indicated at the back.
                    </li>
                  </ul>
                </ul>
              </div>
              <div class="stillHaveQuestion" key="stillHaveQuestion">
                Still have question? Contact us at admin@Bangkoklottery.com
              </div>
            </transition-group>
          </div>
        </div>

        <div class="adsSpace2 desktopOnly">
          <a href="https://www.booking.com/hotel/gr/emerald-suites.en-gb.html" target="_blank"
            >Book your holiday now!</a
          >
        </div>
      </div>
    </div>

    <FooterSection />
  </div>
</template>

<script>
import FloatingMenu from '../components/FloatingMenu';
import FooterSection from '../components/FifthSection';
import MenuBar from '../components/MenuBar';

export default {
  components: {
    FloatingMenu,
    FooterSection,
    MenuBar,
  },
  data: function() {
    return {
      oneActive: false,
      twoActive: false,
      threeActive: false,
      fourActive: false,
      fiveActive: false,
    };
  },
  methods: {
    setDocTitle() {
      if (localStorage.getItem('langChosen') === 'gr') {
        document.title = 'คำถามที่พบบ่อย - Bangkok Lottery';
      } else {
        document.title = 'FAQ - Bangkok Lotteries';
      }
    },
  },
  mounted() {
    this.setDocTitle();
  },
};
</script>

<style>
#faqPage {
  background: url('../assets/backgroundFirstSection.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  min-width: 100vw;
  min-height: 100vh;
  padding: 5vw;
  padding-top: 7.5vw;
  box-sizing: border-box;
}

.faqPageTitle {
  font-size: 165%;
  font-weight: bold;
  color: var(--lightColor);
}

.faqContainer {
  margin-top: 1vw;
  overflow: auto;
  height: 85vh;
}

.faqSingle {
  margin-bottom: 4vw;
}

.faqHead {
  font-weight: bold;
  display: flex;
  align-items: center;
  background-color: var(--yellowPrim);
  color: var(--darkColor);
  margin-top: 4vw;
}

.borderAll {
  border-radius: 1vw;
  padding: 4.5vw;
}

.borderNeeded {
  border-radius: 1vw 1vw 0 0;
  padding: 4.5vw;
}

.faqBody {
  background-color: var(--lightColor);
  padding: 4.5vw;
  border-radius: 0 0 1vw 1vw;
  width: 81vw;
  line-height: 150%;
}

.faqBody p {
  margin-top: 0;
  margin-bottom: 3vw;
}

.faqSign {
  width: 2vw;
  margin-right: 3.5vw;
}

.fadeCustom-enter-active,
.fadeCustom-leave-active {
  transition: all 1s;
}

.fadeCustom-enter,
.fadeCustom-leave-to {
  opacity: 0;
  transform: translateY(-60px);
}

.fadeCustom-move {
  transition: transform 1s;
}

.fadeCustom-leave-active {
  position: absolute;
}

.faqBody ol {
  margin-top: 0;
  padding-left: 6vw;
}

.faqBody li {
  margin-top: 0;
  margin-bottom: 3vw;
}

.faqBody ul {
  margin-top: 0;
  padding-left: 6vw;
}

.stillHaveQuestion {
  color: var(--lightColor);
  margin-top: 4vw;
  text-align: center;
  font-weight: bold;
}

#faqDesktop {
  display: none;
}

@media screen and (min-width: 768px) {
  #faqDesktop {
    background-color: var(--darkColor);
    min-height: 100vh;
    display: block;
  }

  #faqDesktop .heroHeader {
    background-image: url('../assets/faq-banner.jpg'),
      linear-gradient(to right, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.15), rgba(0, 0, 0, 0.6));
    background-blend-mode: multiply;
    background-repeat: no-repeat;
    background-size: cover;
    text-align: center;
    font-size: 6em;
    font-weight: bold;
    color: white;
    padding: 138px 0;
    background-position: top;
    text-shadow: 1px 1px 4px black;
  }

  .aboutDesktopField {
    line-height: 150%;
    font-size: 1.2em;
    width: 60%;
    margin: auto;
    height: 600px;
    overflow: scroll;
    background: var(--bluePrim-lighter-4);
    position: relative;
    top: -50px;
    padding: 15px 40px;
    box-sizing: border-box;
    border-radius: 5px;
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
    margin-bottom: -50px;
  }

  #faqDesktop .adsSpace1,
  #faqDesktop .adsSpace2 {
    width: 18%;
    position: relative;
    z-index: 3;
    text-align: center;
    border-radius: 5px;
    top: -50px;
    margin-bottom: -50px;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3);
  }

  #faqDesktop .faqHead.borderAll {
    border-radius: 5px;
    padding: 15px 25px;
    margin-top: 30px;
    background-color: var(--darkColor);
    color: var(--lightColor);
  }

  #faqDesktop .faqHead {
    margin-top: 30px;
    background-color: var(--darkColor);
    color: var(--lightColor);
    cursor: pointer;
  }

  #faqDesktop .faqBody {
    padding: 25px 30px;
    border-radius: 0 0 5px 5px;
    width: 100%;
    box-sizing: border-box;
  }

  #faqDesktop .faqBody p {
    margin-bottom: 20px;
  }

  #faqDesktop .faqBody ol {
    padding-left: 20px;
  }

  #faqDesktop .faqBody li {
    margin-bottom: 10px;
  }

  #faqDesktop .faqBody ul {
    padding-left: 40px;
  }

  #faqDesktop .faqSign {
    width: 0;
    margin-right: 30px;
  }

  #faqDesktop .borderNeeded {
    border-radius: 5px 5px 0 0;
    padding: 15px 25px;
  }

  #faqDesktop .stillHaveQuestion {
    margin-top: 30px;
    color: var(--bluePrim-darker-5);
  }
}
</style>
